export const APP_ID = "APP_ID";
export const APP_SLUG = "APP_SLUG";
